export default class RecaptchaFix {
    constructor(form_element = '#crud_form') {
        this.form_element = form_element
        this.$form_element = $(this.form_element);
        this.bindEvents();
    }

    bindEvents() {
        this.$form_element.on("submit", (e) => this.submit_with_validations(e));
        globalThis.onCompleted = () => {
            if (this.$form_element.valid()) {
                $(this.form_element).trigger('submit');
            }
        }
    }

    onDestroy() {
        this.$form_element.off("submit", this.submit_with_validations);
    }

    submit_with_validations(e) {
        if(this.$form_element.valid()) {
            if (grecaptcha.getResponse().length === 0) {
                e.preventDefault(); //prevent form submit
                grecaptcha.execute();
            }
        }
    }
}